<template>
  <div class="pageFlexBetweenWrap typeList">
    <div
      class="pageBigRadius pageCarServeShadow listItem"
      v-for="(item, index) in list"
      :key="index"
      :class="`${active === index ? 'active' : ''} ${
        canSel && item.productStock >= 1 ? '' : 'nosel'
      }`"
      @click="selItem(index)"
    >
      <div class="money">
        <p class="pageFontWeight defaultMoney">
          <van-icon
            v-if="iconShow"
            name="play-circle-o"
            style="margin-right: 5px"
          />{{ item.productName }}
        </p>
        <p class="sellMoney">
          ￥{{ $formatMoney(Number(item.productCustomerPrice), 1)
          }}<span v-if="item.productStock <= 0">缺货</span>
        </p>
        <!-- <p class="memberMoney" v-if="vip_discount>0" >
          <font> ￥{{$formatMoney((vip_discount/100)*item.sell_price,0)}}</font>
          <van-tag color="var(--depYelColor)">VIP</van-tag>          
        </p> -->
      </div>
      <van-icon v-if="active === index" class="icons" name="checked" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [
        {
          name: "爱奇艺年卡会员",
          money: "50",
        },
        {
          name: "爱奇艺年卡会员",
          money: "50",
        },
        {
          name: "爱奇艺年卡会员",
          money: "50",
        },
      ],
    },
    canSel: {
      type: Boolean,
      default: true,
    },
    active: Number,
    isMember: Boolean,
    vip_discount: Number,
    iconShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    selItem(i) {
      if (this.canSel && this.list[i].productStock >= 1) {
        this.$emit("selItem", i);
      }
    },
  },
};
</script>

<style scoped lang="less">
.typeList {
  margin-top: -15px;
  .listItem {
    width: 48%;
    position: relative;
    margin-top: 15px;
    border: 2px solid transparent;
    background: #fff;
    color: var(--titleColor);
    padding: 5px 8px;
    box-sizing: border-box;
    .defaultMoney {
      display: flex;
      font-size: 14px;
      align-items: center;
    }
    .discount {
      position: absolute;
      top: -9px;
      right: -11px;
      width: 20px;
      height: 20px;
    }
    .icons {
      position: absolute;
      top: 3px;
      right: 4px;
      color: var(--redColor);
    }
    span {
      float: right;
    }
  }
  .listItem:last-child:nth-child(3n + 2) {
    // margin-right: calc((100% - 30%) / 2);
  }
  .active {
    color: var(--redColor);
    border-color: var(--redColor);
    .memberMoney {
      color: var(--redColor);
    }
  }
  .nosel {
    border-color: transparent;
    color: #ddd;
    .memberMoney {
      color: #ddd;
    }
  }
  .delmoney {
    text-decoration: line-through;
    color: #cccccc;
  }
  .sellMoney {
    font-size: var(--pFont);
    span {
      float: right;
    }
    i {
      background: blue;
      color: #fff;
      padding: 2px;
    }
  }
  .memberMoney {
    font-size: var(--pFont);
    color: #000;
    display: flex;
    align-items: center;
    span {
      margin-left: 3px;
      float: initial;
      height: 10px;
      // background-image: linear-gradient(#ebedf0, #9198e5);
    }
  }
}
</style>
